/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Leveling_Imports_ReadInputs */



/**
* | output |
* | --- |
* | "See level imports and the bot transfer" |
*
* @param {Perm_Product_Leveling_Imports_ReadInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_leveling_imports_read = /** @type {((inputs?: Perm_Product_Leveling_Imports_ReadInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Leveling_Imports_ReadInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видеть импорт уровней и перенос из другого бота")
	return /** @type {LocalizedString} */ ("See level imports and the bot transfer")
});